module.exports = __webpack_public_path__ + "img/GoPay-650x340.3bf7516a.png";